export const CHAT_PLATFORM = {
  WHATSAPP: 'DIALOG360_WHATSAPP',
}
